export default "__VITE_ASSET__jneaW6Pm__"